import React from "react";
import { Box, useTheme } from "@mui/material";

const StepperConnector: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flex: 1,
        minWidth: theme.nawy.spacing.md,
        height: "1px",
        backgroundColor: theme.nawy.colors.semantic.border.secondary,
        transition: "flex 0.2s ease-in-out",
      }}
    />
  );
};

export default StepperConnector;
